import React, { useRef } from 'react'
import { PageHead } from '@fs/zion-head'
import { useTranslation } from 'react-i18next'
import { usePageWidth } from '@fs/zion-ui'
import TopSection from './TopSection'
import JumpLinks from './JumpLinks'
import EverythingFree from './EverythingFree'
import FamilyTree from './FamilyTree'
import HistoricalDocuments from './HistoricalDocuments'
import SpecialCollections from './SpecialCollections'
import GettingStarted from './GettingStarted'
import HelpAndLearning from './HelpAndLearning'
import SignUp from './SignUp'
import socialShareImg from './images/top-section-image-mobile.webp'

export default function UnitedStatesPage({ canonicalUrl }) {
  const { t } = useTranslation()
  const atPageWidth = usePageWidth()
  const jumpLinksRef = useRef()
  const scrollStyles = { scrollMarginTop: jumpLinksRef.current?.offsetHeight }

  return (
    <>
      <PageHead
        title={t('nlihp.united-states.page-title', 'Find your family. Free Genealogy Archives')}
        description={t(
          'nlihp.united-states.page-description',
          'Become a part of the best ancestry website community through FamilySearch, and discover how our free Family Trees and records can help you uncover your past.'
        )}
        image={{ url: socialShareImg, width: 1200, height: 630 }}
        includeHreflang={false}
        url={canonicalUrl}
      />
      <TopSection />
      {atPageWidth({ default: false, lg: true }) && <JumpLinks jumpLinksRef={jumpLinksRef} />}
      <EverythingFree />
      <div style={scrollStyles} id="FamilyTree">
        <FamilyTree />
      </div>
      <div id="HistoricalDocuments" style={scrollStyles}>
        <HistoricalDocuments />
        <SpecialCollections />
      </div>
      <div id="GetStarted" style={scrollStyles}>
        <GettingStarted />
      </div>
      <div id="HelpandLearning" style={scrollStyles}>
        <HelpAndLearning />
      </div>
      <SignUp />
    </>
  )
}
